module.exports = __webpack_public_path__ + "static/img/2.8c29749.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/afterSale/2.jpg
// module id = 9sce
// module chunks = 1